import { mediaQuery } from 'components';
import styled, { keyframes } from 'styled-components';

export const ReturnToProjectBackground = styled.div`
  background-size: cover;
  display: flex;
  align-items: start;
  justify-content: center;
  width: 100%;
  position: relative;

  ${mediaQuery.medium`
    position: absolute;
    align-items: center;
    height: calc(100vh - 80px);
    z-index: 9;
  `};
`;

export const ReturnToProjectContainer = styled.div`
  display: flex;
  flex-direction: column-reverse;
  width: 100%;
  max-width: 100vw;

  background: rgba(240, 240, 240, 0.95);

  ${mediaQuery.medium`
    flex-direction: row;
    width: 1165px;
    height: 402px;
  `};
`;

export const GreetingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  border-top: 2px solid #000000;
  background: rgba(255, 255, 255, 0.9);
  margin-top: -71px;
  z-index: 9;

  ${mediaQuery.medium`
    background: rgba(240,240,240,0);
    border: none;
    max-width: 611px;
    height: 244px;
    margin: 77px auto;
  `};
`;

export const Greeting = styled.span`
  font-family: 'Crimson Text, Minion Pro';
  font-style: normal;
  font-weight: 100;
  font-size: 26px;
  line-height: 28px;

  text-align: center;

  color: #000000;
  padding-bottom: 12px;
  margin-top: 18px;

  ${mediaQuery.medium`
    font-size: 48px;
    line-height: 32px;
    margin: 0;
    padding-bottom: 34px;
  `};
`;

export const GreetingSubtext = styled.span`
  width: 309px;

  font-family: 'Lato';
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 18px;

  text-align: center;

  color: #000000;
  padding-bottom: 24px;

  ${mediaQuery.medium`
    padding-bottom: 35px;
    line-height: 22px;
  `};
`;

export const LoadingBarContainer = styled.div`
  position: relative;
  width: 100%;
  bottom: 0;
`;

export const GoToProjectLink = styled.a`
  box-sizing: border-box;
  width: 215px;
  height: 44px;
  left: 288px;
  top: 235px;

  background: #000000;
  border-radius: 2px;
  font-family: 'Lato';
  font-style: normal;
  font-weight: 900;
  font-size: 10px;
  line-height: 44px;

  text-align: center;

  color: #ffffff !important;
  margin-bottom: 32px;

  &:hover {
    opacity: 0.8;
  }

  ${mediaQuery.medium`
    border-radius: 4px;
  `};
`;

export const GoToProjectsPageButton = styled.button`
  font-family: 'Lato';
  font-style: normal;
  font-weight: 600;
  font-size: 10px;
  line-height: 14px;

  text-align: center;
  letter-spacing: 0.25px;

  color: #000000;
  border: none;
  cursor: pointer;
  background: none;
  margin-bottom: 16px;

  ${mediaQuery.medium`
    height: 14px;
    margin: 0;

    font-family: 'Lato';
    font-style: normal;
    font-weight: 900;
    font-size: 14px;
    line-height: 14px;

    text-align: center;
    text-decoration-line: underline;


    &:hover {
      opacity: 0.8;
    }
  `};
`;

export const ProjectThumbnailContainer = styled.div`
  width: 100%;
  height: 100vw;

  ${mediaQuery.medium`
    width: 400px;
    height: 400px;
    flex-shrink: 0;
  `};
`;

export const DesktopProjectLoadingBarContainer = styled.div`
  display: none;

  ${mediaQuery.medium`
    display: inherit;
    position: relative;
    width: 157px;
    height: 52px;
    top: 325px;
    margin: auto;

    background: rgba(240, 240, 240);
  `};
`;

export const MobileProjectLoadingBarContainer = styled.div`
  width: 100%;
  ${mediaQuery.medium`
    display: none;
  `};
`;

export const ProjectName = styled.div`
  font-family: 'Lato';
  font-style: normal;
  font-weight: 900;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.25px;
  color: #000000;
  text-align: center;
  padding-top: 12px;
  padding-bottom: 2px;
  word-wrap: break-word;
`;

export const Description = styled.div`
  padding-right: 26px;
  text-align: right;
  font-family: 'Crimson Text, Minion Pro';
  font-style: italic;
  font-weight: 400;
  font-size: 10px;
  line-height: 10px;
  color: #757575;
  padding-bottom: 8px;

  ${mediaQuery.medium`
    margin: auto;
    text-align: center;
  `};
`;

const fadeIn = keyframes`
  from {
    background-color: rgba(255,255,255, 0.8);
  }
  to {
    background-color: rgba(255,255,255, 1.0);
  }
`;

export const DismissReturnToProject = styled.div`
  background-color: rgba(255, 255, 255, 0.8);
  cursor: pointer;
  width: 32px;
  height: 32px;
  border-radius: 2px;
  padding: 6px 10px;
  float: right;
  -webkit-transition: background-color 0.2s linear;

  &:hover {
    background-color: rgba(255, 255, 255, 1);
    animation: ${fadeIn} 0.2s linear;
  }
`;
export const DismissReturnToProjectContainer = styled.div`
  position: absolute;
  width: inherit;
  top: 0px;
  padding: 18px 28px 0 0;

  ${mediaQuery.medium`
    top: inherit;
  `};
`;
